import React, { FC } from 'react'
import { Checkbox, Typography, FormControlLabel, FormControlLabelProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Controller, useFormContext } from 'react-hook-form'

const useStyles = makeStyles({
  input: {
    fontWeight: 'bold',
  },
})

interface IFormCheckbox {
  props?: FormControlLabelProps
  name: string
  label?: string
  render?: JSX.Element
  // handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  // checked?: boolean
}

export const InputCheckbox: FC<IFormCheckbox> = ({ name, label, render }) => {
  const classes = useStyles()
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormControlLabel
          {...field}
          control={<Checkbox checked={field.value || false} name={field.name} onChange={field.onChange} />}
          label={
            <Typography className={classes.input} variant={'body2'}>
              {label || render}
            </Typography>
          }
        />
      )}
    />
  )
}
